<template>
  <div class="disable-scroll-x">
  <Mainlayout></Mainlayout>
    <br /><br /><br />
    <div>
      <CContainer>
        <h3 class="display-4 text-center">Join Class</h3>
        <h5 class="display-6 text-center">
          Let's join our class to improve your skill and gain knowledge
        </h5>

        <CCol sm="12" class="mt-5">
          <CCol sm="6">
            <CSelect
              :value.sync="selectedGrade"
              :options="gradeOptions"
              @change="FilterPackage()"
            />
          </CCol>
          <CRow class="p-3">
            <CCol
              sm="6"
              v-for="(item, index) in FilterPackages"
              v-bind:key="item.Id"
            >
              <CCard @click="GoToDetail(item.Id, item.ScheduleId)">
                <img :src="getPic(index)" style="max-width: 100%" />
                <br />
                <div class="p-3">
                  <h4>
                    <strong
                      style="
                        font-size: 1.75rem;
                        line-height: 2rem;
                        font-family: Source Sans Pro, Arial, sans-serif;
                        font-weight: 400;
                      "
                      class="ml-3 mr-3 mt-5"
                      >{{ item.Name }}
                    </strong>
                  </h4>
                  <!-- <h5 class="mt-2 ml-3"> {{ item.Description }} </h5> -->
                  <br />
                  <h6 class="mt-2 ml-3 small text-muted">
                    Date :

                  {{ item.DateTimeSchedule }}
                  </h6>
                  <h6 class="mt-2 ml-3 small text-muted">
                    Grade : {{ item.Grade }}
                  </h6>
                </div>
              </CCard>
            </CCol>
          </CRow>
        </CCol>
      </CContainer>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import backgroundBanner from "../assets/img/bgApps.jpg";
import Mainlayout from "../containers/AllHeaderLanding.vue";
Vue.use(VuejsDialog);
import _ from "lodash";

export default {
  name: "Login",
   components: {
    Mainlayout
  },
  data() {
    return {
      backgroundBanner,
      packages: [],
      SelectedPackage: "",
      PackageDescription: "",

      urlApp: [],
      FilterPackages: [],
      selectedGrade: "",
      gradeOptions: [],
    };
  },
  async mounted() {
    this.GetAllPackages();
     this.googleTranslateElementInit();
  },
  computed: {
     CreationDate: {
      get: function () {
        return moment().format("DD-MM-YYYY");
      },
    },
    
  },
  methods: {
    async GetAllPackages() {
      return this.$API
        .get(this.$AllClassPackage)
        .then(
          function (response) {
            this.packages = response.data;
               this.FilterPackages = this.packages;

           
         

            var scheduleNames = _.uniq(_.map(response.data, "Grade"));
            scheduleNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });

            this.gradeOptions = scheduleNames;
            this.gradeOptions.unshift("SELECT GRADE");
           



            this.getPic(this.packages.filePath);
           
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    getPic(index) {
      return "https://pickiddo.com" + this.FilterPackages[index].filePath;
    },
    GoToDetail(Id,ScheduleId) {
      this.$router.push("/DetailJoinClass?id=" + Id + "&scheduleId=" + ScheduleId);
    },
    // FilterPackage() {
    //   console.log("masuk");
       
    //   this.FilterPackages = this.packages;


    //   this.FilterPackages = _.filter(
    //     this.FilterPackages,
    //     (item) => item.Name === this.selectedGrade
    //   );
      
    // },

      FilterPackage() {
      console.log("masuk req");
      this.FilterPackages = this.packages;

      if (this.selectedGrade!== "ALL GRADE")
        this.FilterPackages = _.filter(
          this.FilterPackages,
          (item) => item.Grade === this.selectedGrade
        );
    },
  },
};
</script>

<style>
body {
  background: #fff;
}
.carousel-indicators li {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #000015;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  -webkit-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}

.custom-font {
  font-family: "Rubik", sans-serif;
}

.change_color {
  background-color: red;
}

* {
  padding: 0;
  margin: 0;
}

body {
  height: 100vh;
}
body nav {
  position: fixed;
  width: 100%;
  height: 70px;
  background-color: transparent;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
}
body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}

.c-header {
  background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83;
  /* color: #fff; */
}

@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap");
</style>

